import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Car, LogOut, Settings } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_EMAIL = 'andrej.klimek@gmail.com';

function Header() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const userData = await response.json();
        setCurrentUser(userData);
        setIsAdmin(userData.email === ADMIN_EMAIL);
      }
    } catch (error) {
      // User not logged in, that's ok
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${BACKEND_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
      setCurrentUser(null);
      setIsAdmin(false);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header data-testid="main-header" className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <div className="flex items-center gap-2 sm:gap-3 cursor-pointer" onClick={() => navigate('/')} data-testid="logo-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_a65584c5-22b3-4ad8-951b-58f1980c5cae/artifacts/hts8ypom_logo_green_top.jpg" 
              alt="EVMarket Logo" 
              className="h-9 w-9 sm:h-12 sm:w-12 rounded-full"
            />
            <div>
              <h1 className="text-base sm:text-xl font-bold text-primary" style={{fontFamily: 'Manrope, sans-serif'}}>EVMarket</h1>
              <p className="text-[10px] sm:text-xs text-slate-600 hidden sm:block">inzercia zdarma</p>
            </div>
          </div>

          <div className="flex items-center gap-1.5 sm:gap-3">
            <Button
              data-testid="add-listing-button"
              onClick={() => navigate('/create-listing')}
              className="bg-accent text-white hover:bg-lime-600 font-semibold tracking-wide h-8 sm:h-9 px-2 sm:px-4 text-xs sm:text-sm"
            >
              <Plus className="h-4 w-4 sm:mr-1" />
              <span className="hidden sm:inline">Vložiť EV</span>
              <span className="sm:hidden">Vložiť</span>
            </Button>
            <Button
              data-testid="my-listings-button"
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="border-slate-200 hover:bg-slate-50 h-8 sm:h-9 px-2 sm:px-4 text-xs sm:text-sm"
            >
              <Car className="h-4 w-4 sm:mr-1" />
              <span className="hidden sm:inline">Moje EV</span>
              <span className="sm:hidden">Moje</span>
            </Button>
            {isAdmin && (
              <Button
                data-testid="admin-button"
                onClick={() => navigate('/admin')}
                variant="outline"
                className="border-slate-200 hover:bg-slate-50 h-8 sm:h-9 px-2 sm:px-4 text-xs sm:text-sm"
              >
                <Settings className="h-4 w-4 sm:mr-1" />
                <span className="hidden sm:inline">Admin</span>
              </Button>
            )}
            {currentUser && (
              <Button
                data-testid="logout-button"
                onClick={handleLogout}
                variant="outline"
                className="border-slate-200 hover:bg-slate-50 text-red-600 hover:text-red-700 hover:bg-red-50 h-8 sm:h-9 px-2 sm:px-4 text-xs sm:text-sm"
              >
                <LogOut className="h-4 w-4 sm:mr-1" />
                <span className="hidden sm:inline">Odhlásiť</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
